import * as React from "react";
import { useState, useCallback } from "react";
import { RenderCompletionObserver } from "components/visualizations";
import useParams from "routing/useParams";
import { Spinner } from "components/common";
import useExportData from "export/useExportData";
import ThreatCoverageExportPage, { RENDER_TYPE } from "export/ThreatCoverageExportPage";
import RenderTypeNotSupported from "export/RenderTypeNotSupported";
import { Container, InvisibleDiv } from "export/Components";
import ExportErrorBoundary from "export/ExportErrorBoundary";
const supportedTypes = [RENDER_TYPE];
const ExportPage = () => {
  const { exportCallId } = useParams();
  const { isFetching, data } = useExportData(exportCallId);
  const [isRenderComplete, setIsRenderComplete] = useState(false);
  const handleRenderComplete = useCallback(() => {
    setIsRenderComplete(true);
  }, []);
  if (isFetching) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(RenderCompletionObserver, { onRenderComplete: handleRenderComplete }, /* @__PURE__ */ React.createElement(ExportErrorBoundary, null, /* @__PURE__ */ React.createElement(React.Fragment, null, data.widget.renderType === "threat_coverage" && /* @__PURE__ */ React.createElement(ThreatCoverageExportPage, { data }), !supportedTypes.includes(data.widget.renderType) && /* @__PURE__ */ React.createElement(RenderTypeNotSupported, { renderType: data.widget.renderType })))), /* @__PURE__ */ React.createElement(InvisibleDiv, { id: "render-started" }), isRenderComplete && /* @__PURE__ */ React.createElement(InvisibleDiv, { id: "render-complete" }));
};
export default ExportPage;
